/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { PRODUCT_INFO_STATE_KEY } from '@/data/constants/product';

export const SKIP_STORAGE_KEY = [PRODUCT_INFO_STATE_KEY];
